export default "__VITE_ASSET__5d32f297__"